<template>
  <div class="hello" style="background-color:#f5f5f5f8; height:auto; padding-bottom: 180px;">
    <van-sticky class="item-pop">
      <div style="position: relative; max-width: 640px; left:auto; margin: 0 auto;">
        <van-nav-bar style="height:40px;background: rgb(53, 120, 229)" :border="false" @click-left="onClickLeft">
          <template #left>
            <van-icon style=" font-weight: 900;" name="arrow-left" color="#FFFFFF" size="25"/>
          </template>
          <template #title>
            <span style="color:#FFFFFF; font-weight: 700; font-size: 19px;">結賬</span>
          </template>
        </van-nav-bar>
      </div>
    </van-sticky>
    <div style="max-width: 640px; background: rgb(53, 120, 229); left:auto; margin: 0 auto;height: 130px; border-radius: 0% 0% 50% 50%;">
      <div style="margin-left:15px; display: inline-flex">
      </div>
    </div>
    <van-cell-group style="border-radius:10px; margin-top:-100px; margin-left:20px; margin-right:20px;" :border="false">
      <van-cell style="border-radius:10px; height:auto;" size="large" :border="false">
        <template>
        <span class="Details-title">商品清單</span>
         <van-cell v-for="(item,index) in list" :key="index" style=" min-height: 80px; background-color: #f5f5f5f8; margin-top: 10px;">
            <template #icon>
              <van-image style="position: relative; left: -10px; width:70px; height: 70px;"  :src="item.itemImg"/>
            </template>
            <template #title>
              <span style="position: relative; top: -10px; font-size: 14px;"> {{ item.itemTitle }}</span>
            </template>
            <template #label>
              <div style="position: relative; top: -15px; text-align:left;">
                <van-collapse v-model="activeNames"  :border="false">
                  <van-collapse-item :name="item.uid" style="border-radius:50px;">
                    <template #title>
                      <span style="font-size: 11px; margin-left: -15px;"> {{ item.packName }}</span>
                    </template>
                    <template>
                      <span style="font-size: 11px;"> {{ item.specsContent }}</span>
                    </template>
                  </van-collapse-item>
                </van-collapse>
              </div>
            </template>
            <template #right-icon>
              <span style="position:absolute; text-align: right; right: 10px; bottom: 0px; font-weight: 700; color: rgb(53, 120, 229)"> {{ item.currency }}$ {{ item.price }}</span>
            </template>
          </van-cell>
      </template>
      </van-cell>
    </van-cell-group>
    <van-cell-group style="border-radius:10px; margin-left:20px; margin-right:20px; margin-bottom: 10px;" :border="false">
      <van-cell style=" height: 50px; background-color: #f5f5f5f8; margin-top: 10px;" :border="false">
        <template #title>
          <span style="position:absolute; text-align: right; right: 10px; top: 5px;"> 共計<span style="color: rgb(53, 120, 229); font-weight:700;">{{list.length}}</span>件商品</span>
        </template>
        <template #right-icon>
          <span style="position:absolute; text-align: right; right: 10px; top: 25px;"> 總價：<span style="color: rgb(53, 120, 229); font-weight:700;">NT$ {{price}}</span></span>
        </template>
      </van-cell>
    </van-cell-group>
      <van-cell-group style="border-radius:10px; margin-left:20px; margin-right:20px;" :border="false">
      <van-cell style="border-radius:10px; height:auto;" size="large" >
        <template>
        <span class="Details-title">配送資料</span>
        <van-tabs class="typeCard" type="card" color="rgb(53, 120, 229)" v-model="express" @change="onChangeDelivery">
          <van-tab name="新竹物流">
            <template #title>
              <div style="text-align:center; display:flex;align-items: center;">
                <van-image width="20px" height="20px" src="./static/icon_car.svg"/>
              <span>宅配到府</span>
              </div>
            </template>
          </van-tab>
          <van-tab name="7-11">
            <template #title>
              <div style="text-align:center; display:flex;align-items: center;">
                <van-image width="20px" height="20px" src="./static/icon_store.svg"/>
              <span>7-11取貨</span>
              </div>
            </template>
          </van-tab>
          <van-tab name="全家">
            <template #title>
              <div style="text-align:center; display:flex;align-items: center;">
                <van-image width="22px" height="22px" src="./static/icon_quanjia.svg"/>
              <span>全家取貨</span>
              </div>
            </template>
          </van-tab>
        </van-tabs>
        <van-cell style=" border-radius:5px; height: 90px; background-color: #f5f5f5f8; margin-top: 10px;" :border="false">
        <template #title>
          <span style="position:relative; top: -10px; left: -8px; font-size:14px;">收貨資料</span>
        </template>
        <template #label>
          <span v-if="!addrId" style="position:relative; top: -10px; left: -8px; font-size:14px;">請選擇收貨資料以完成訂單</span>
          <div v-else>
            <span style="position:relative; top: -10px; left: -8px; font-size:14px; font-weight: 400;">{{ addrInfo.name }} {{ addrInfo.tel }}</span><br>
            <span style="position:relative; top: -10px; left: -8px; font-size:11px; ">{{ addrInfo.address }}</span>
          </div>
        </template>
        <template #right-icon>
          <van-button  style="margin-top:15px;" square type="info" @click="selectAddr()">選擇地址</van-button>
        </template>
      </van-cell>
      <van-cell style=" border-radius:5px; height: 60px; background-color: #f5f5f5f8; margin-top: 10px;" :border="false">
        <template #title>
          <span style="position:relative; top: -10px; left: -8px; font-size:14px;">付款方式</span>
          <van-radio-group v-model="payment" disable>
            <van-radio name="1" shape="square" checked>貨到付款</van-radio>
          </van-radio-group>
        </template>
      </van-cell>
      <van-cell style=" border-radius:5px; height: 140px; background-color: #f5f5f5f8; margin-top: 10px;" :border="false">
        <template #title>
          <span style="position:relative; top: -10px; left: -8px; font-size:14px;">訂單留言</span>
          <van-field
            v-model="memo"
            rows="2"
            autosize
            height="60px"
            type="textarea"
            maxlength="50"
            placeholder="如有需要，請輸入您的留言"
            show-word-limit
          />
        </template>
      </van-cell>
      </template>
      </van-cell>
    </van-cell-group>
    <van-popup
      class="item-pop"
      v-model="showPicker"
      closeable
      position="bottom"
      :style="{ height: '95%'}"
    >
      <template>
        <div style="margin-left:10px; margin-top:15px;">
          <span>請選擇收貨資料</span>
        </div>
        <div style="padding-bottom: 120px;">
          <van-empty v-if="addrList.length <= 0" description="暫無收貨資料，請點下方添加資料" />
          <van-cell-group v-else style=" margin-top:10px; margin-right: 10px; margin-left: 10px;" :border="false">
            <van-cell  style="margin-top:10px;" v-for="(item,index) in addrList" :key= "index" size="large" :border="false" is-link center @click="onSelect(index,item.id)">
              <template #title>
                <span style="font-size:16px;">{{item.name + ' ' + item.tel}}</span>
              </template>
              <template #label>
                <span style="font-size:12px;">{{item.address}}</span>
              </template>
              <template  #right-icon>
                <van-icon name="arrow" color="#969799" size="20px" />
              </template>
            </van-cell>
            <template #right>
              <van-button square type="danger" text="刪除" class="delete-button" />
            </template>
          </van-cell-group>
        </div>
        <div>
          <van-button style="position: fixed; max-width: 640px; min-width: 320px; bottom: 0px;" square  type="primary" size="large" color="rgb(53, 120, 229)" to="/address/add">新增地址</van-button>
        </div>
      </template>
    </van-popup>
    <van-submit-bar
      class="action-bar"
      :price="price * 100"
      :decimal-length="0"
      label="合計："
      currency="NT$"
      safe-area-inset-bottom
      tip-icon="info-o"
      tip="商品到貨後我們將通知您取貨，請及時取貨唷~"
    >
      <template #button>
        <van-button class="action-button" round type="info" @click="onSubmit">提交訂單</van-button>
      </template>
    </van-submit-bar>
    <div style="margin-top:20px; padding-bottom:50px;">
      <van-collapse v-model="activeTerms">
        <van-collapse-item title="用戶須知" name="1">本產品的實際使用效果根據個人情況決定，不保證每位用戶都能享受到所宣傳的效果。若有疑問請通過在線客服聯絡我們，本公司享有最終解釋權。</van-collapse-item>
        <van-collapse-item title="物流配送" name="2">貨物一般在訂單確認的5~10個工作日送達，出現突發狀況可能會有所延遲。貨物送達前都會提前聯絡客戶，請保持電話暢通。</van-collapse-item>
        <van-collapse-item title="退貨流程" name="3">確認收貨—申請退換貨—客服審核通過—用戶寄回商品—倉庫簽收驗貨—退換貨審核—退款/換貨；退換貨請註明：訂單號、姓名、電話。</van-collapse-item>
        <van-collapse-item title="關於我們" name="4">小泉士多致力於為客戶提供優質的商品，並以此爲目標不斷努力。爲了保障您的權益，購物前請認準我們的官方網站和社交媒體。</van-collapse-item>
        <van-collapse-item title="聯絡我們" name="5">如果您有問題需要幫助，可以通過在線客服與我們聯絡，或前往我們的Facebook主頁。客服電郵：support@koizumishop.com</van-collapse-item>
      </van-collapse>
    </div>
    <div style="margin:0 auto; text-align:center; padding-bottom: 80px;">
      <span style="color: #606266; font-size:0.6rem;">@小泉士多 KOIZUMISHOP</span>
      <div style="margin-top:20px;">
        <ul style="display: inline-flex;list-style: none;"><li style="margin-right: 14px;"><a style="color:#606266; text-decoration: none;font-size:0.6rem;" href="/privacy">隱私政策</a></li><li><a style="color:#606266; text-decoration: none;font-size:0.6rem;" href="/terms">服務條款</a></li></ul>
      </div>
    </div>
  </div>
</template>
<script>
import { Toast, Notify } from 'vant'
import { getAddrList } from '@/api/address'
import { getUser } from '@/utils/auth'
import { addOrder } from '@/api/order'

export default {
  name: 'HelloWorld',
  components: {
  },
  data () {
    return {
      express: '',
      type: '1',
      payment: '1',
      activeNames: ['1'],
      activeTerms: ['1'],
      showPicker: false,
      addrId: undefined,
      addrInfo: {},
      addrList: [],
      price: 0,
      list: [],
      memo: '',
      recomm: []
    }
  },
  created () {
  },
  mounted () {
    this.list = JSON.parse(sessionStorage.getItem('checkout'))
    for (var i = 0; i < this.list.length; i++) {
      this.price += parseInt(this.list[i].price)
    }
    // document.addEventListener('deviceready', this.onDeviceReady, false)
  },
  methods: {
    /* onDeviceReady (device) {
      console.log(device.uuid)
      // Notify({ type: 'warning', message: device.uuid })
    }, */
    onClickLeft () {
      this.$router.back(-1)
      window.scrollTo(0, 0)
    },
    onSubmit () {
      if (this.addrId === undefined) {
        Notify({ type: 'warning', message: '請完善收貨資料' })
        return
      }
      // 验证通过
      Toast.loading({
        message: '訂單創建中...',
        forbidClick: true,
        loadingType: 'spinner',
        duration: 1000
      })

      addOrder({ customer: getUser(), addr: this.addrId, list: this.list, memo: this.memo, deliveryType: this.type, express: this.express, browser: localStorage.getItem('browserId') }).then(res => {
        if (res.code === 200) {
          Notify({ type: 'success', message: '創建訂單成功' })
          this.show = false
          window.scrollTo(0, 0)
          this.result = false
          this.resultData = res.data
          // var query = { sn: res.data.sn, date: res.data.date, addr: this.addrId, list: this.list, memo: this.memo, type: this.type, addrInfo: this.addrInfo }
          Toast.clear()
          this.$router.replace({path: '/success', query: {sn: res.data.sn, date: res.data.date, list: JSON.stringify(this.list), memo: this.memo, type: this.type, express: this.express, addrInfo: JSON.stringify(this.addrInfo)}})
        } else {
          Notify({ type: 'danger', message: res.message })
          Toast.fail(res.message)
        }
      })
    },
    onSelect (index, id) {
      this.showPicker = false
      this.addrId = id
      this.addrInfo = this.addrList[index]
      console.log(this.addrInfo)
    },
    selectAddr () {
      this.showPicker = true
      this.getAddressList()
    },
    getAddressList () {
      this.addrList = []
      Toast.loading({
        message: '加載中...',
        forbidClick: true,
        loadingType: 'spinner',
        duration: 3000
      })
      getAddrList({ user: getUser(), type: this.type, express: this.express }).then(res => {
        if (res.code === 200) {
          this.addrList = res.data
          Toast.clear()
        } else {
          Toast.fail('加載出錯，請刷新重試')
        }
      })
    },
    onChangeDelivery (e) {
      this.addrId = undefined
      this.addrInfo = {}
      if (e === '新竹物流') {
        this.type = '1'
      } else {
        this.type = '2'
      }
    },
    gotoItem (link) {
      window.scrollTo(0, 0)
      this.$router.push({ path: '/' + link })
      Toast.loading({
        message: '加載中...',
        forbidClick: true,
        loadingType: 'spinner',
        duration: 200
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.Price-title {
    margin-right: 4px;
    vertical-align: middle;
    color: #3578e5;
    float: left;
    font-weight: 700;
    font-size: 24px;
  }
  .item-pop {
    left:auto;
    height: 95%;
    min-width: 320px;
    max-width:640px;
    background-color:#f4f5f5;
  }
  .recomm-cell{
  border-radius:20px;
  padding-left: 10px !important;
  padding-right: 10px !important;
  padding-top: 0px !important;
  }
  .recomm-cell .van-grid >>>.van-grid-item__content {
  padding-top: 2px !important;
  padding-left: 8px !important;
  }
  .typeCard {
    margin-top:10px;
  }
  .typeCard>>>.van-tabs__wrap {
    height: 40px !important;
  }

  .typeCard>>>.van-tabs__nav--card {
    height: 40px !important;
  }
  .action-bar {
    position: fixed;
    left:auto;
    max-width:640px;
    margin:0 auto;
    z-index:1000;
  }
  .action-button {
    color: #FFFFFF;
    background-color:rgb(53, 120, 229);
    width: 40%;
  }
</style>



// WEBPACK FOOTER //
// src/components/Checkout.vue